/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   Settings for the browser
 * Read and update with any changes: https://zumper.atlassian.net/wiki/spaces/PLAT/pages/565084375/
 */

import { getLiveEnv } from '@zcode/settings'

export const STATIC_FONTS_URL = process.env.REACT_APP_STATIC_FONTS_URL

export const NOMAD_ALLOC_ID = getLiveEnv('NOMAD_ALLOC_ID')
